import { render, staticRenderFns } from "./PeriodsForm.vue?vue&type=template&id=042f5410&scoped=true"
import script from "./PeriodsForm.vue?vue&type=script&lang=js"
export * from "./PeriodsForm.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./PeriodsForm.vue?vue&type=style&index=1&id=042f5410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042f5410",
  null
  
)

export default component.exports